import { AppConfig } from '@ltvco/refresh-lib/ctx';
import { Stack } from '@ltvco/refresh-lib/theme';
import { Close } from '@mui/icons-material';
import { useContext } from 'react';

import {
  BannerContainer,
  BannerContent,
  BannerText,
  GoodhoodCtaButton,
  PrimaryText,
  SecondaryText,
  StyledCloseButton,
} from './components';

interface GoodhoodPromoBannerProps {
  isVisible: boolean;
  setIsVisible: (isVisible: boolean) => void;
}

export const GoodhoodPromoBanner = ({
  isVisible,
  setIsVisible,
}: GoodhoodPromoBannerProps) => {
  const { trackEventGA4 } = useContext(AppConfig);

  const handleClose = () => {
    setIsVisible(false);
  };

  const navigateToLink = () => {
    window.open(
      'https://www.goodhood.auto/?utm_source=bumper',
      '_blank',
      'noopener,noreferrer',
    );
    trackEventGA4({
      event_name: 'header_engagement',
      type: 'goodhood CTA',
    });
    handleClose();
  };

  if (!isVisible) return null;

  return (
    <BannerContainer data-testid="goodhood-promo-banner">
      <BannerContent>
        <Stack flexDirection="row" alignItems="center">
          <BannerText>
            <PrimaryText id="first-text">
              Free Goodhood Oil Change for Dallas Members!
            </PrimaryText>{' '}
          </BannerText>
          <GoodhoodCtaButton
            onClick={navigateToLink}
            data-testid="setup-button"
          >
            <SecondaryText>Claim Offer</SecondaryText>
          </GoodhoodCtaButton>
        </Stack>
        <StyledCloseButton onClick={handleClose} data-testid="close-button">
          <Close fontSize="small" />
        </StyledCloseButton>
      </BannerContent>
    </BannerContainer>
  );
};
